module.exports = __webpack_public_path__ + "static/img/detail-wrightin.dc238c53.png";